import { eflowApi } from "../../lib/api";
export const getAssetsChargingOptions = async (assets, projectId, chargeFilter) => {
    const requestBody = {
        assets,
        projectId
    };
    const { data } = await eflowApi.post(`/assets/chargeOptions${chargeFilter ? `?chargeUpto=${chargeFilter}` : ""}`, requestBody);
    return data;
};
export const getFutureChargingOptions = async (requestBody, chargeUpto) => {
    const { data } = await eflowApi.post(`/assets/chargeOptions/future?chargeUpto=${chargeUpto}`, requestBody);
    return data;
};
/**
 * Update or deactivate a charger asset link
 * @param requestBody - The update request containing link details and status
 * @returns Promise<void>
 */
export const patchChargerLink = async (requestBody) => {
    const { data } = await eflowApi.patch("/assets/chargers/links", requestBody);
    return data;
};
/**
 * Alias for patchChargerLink - updates or deactivates a charger asset link
 * @deprecated Use patchChargerLink instead for consistency
 */
export const updateOrDeactivateChargerLink = patchChargerLink;
